import React, { useMemo } from 'react';

import { customTheme } from 'theme';

import { LineChart } from 'components/Visualization';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import {
  customizedXAxisTick,
  rotatedXAxisTick,
} from 'components/Visualization/Charts/utils';

import { CloudEventsSummaryChartProps } from '../../../types';

import {
  formatCloudEventsSummaryTime,
  getCloudEventsSummaryXAxisInterval,
} from './utils';

const ANOMALY = 'Anomaly';
const MALICIOUS = 'Malicious';

export const InsightsSummary = ({
  summary,
  isHourly,
  summaryPeriod,
}: CloudEventsSummaryChartProps) => {
  const chartData = useMemo(
    () =>
      summary.data?.by_insight?.map(point => ({
        Date: formatCloudEventsSummaryTime(point),
        [ANOMALY]: Number(point.anomalous ?? 0),
        [MALICIOUS]: Number(point.malicious ?? 0),
      })) ?? [],
    [summary.data?.by_insight],
  );

  return (
    <DashboardWidget
      label="By Insights"
      subHeader={isHourly ? undefined : summaryPeriod ?? 'Last 7 days'}
      isLoading={summary.isLoading}
      noData={!chartData.length}
      noDataMessage="No insights available"
      paddingX={0}
      paddingBottom={1}
      content={
        <LineChart
          data={chartData}
          xField="Date"
          yField={[ANOMALY, MALICIOUS]}
          colorMap={{
            [ANOMALY]: customTheme.colors.orange['400'],
            [MALICIOUS]: customTheme.colors.critical,
          }}
          styles={{
            lineChart: {
              margin: { bottom: -15, left: 0 },
            },
            line: {
              strokeWidth: 2,
            },
            xAxis: {
              tick: isHourly ? customizedXAxisTick : rotatedXAxisTick,
              height: isHourly ? 30 : 55,
              interval: getCloudEventsSummaryXAxisInterval(
                isHourly,
                chartData.length,
              ),
            },
            yAxis: {
              axisLine: false,
              tickLine: false,
              //width: 65,
            },
          }}
        />
      }
    />
  );
};
